/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PastMedicalHistoryDto } from './PastMedicalHistoryDto';
import {
    PastMedicalHistoryDtoFromJSON,
    PastMedicalHistoryDtoFromJSONTyped,
    PastMedicalHistoryDtoToJSON,
    PastMedicalHistoryDtoToJSONTyped,
} from './PastMedicalHistoryDto';

/**
 * 
 * @export
 * @interface MedicalHistoryResponseDto
 */
export interface MedicalHistoryResponseDto {
    /**
     * Patient ID
     * @type {string}
     * @memberof MedicalHistoryResponseDto
     */
    patientId: string;
    /**
     * Past medical history
     * @type {PastMedicalHistoryDto}
     * @memberof MedicalHistoryResponseDto
     */
    pastMedicalHistory?: PastMedicalHistoryDto;
    /**
     * Surgeries/hospitalizations
     * @type {string}
     * @memberof MedicalHistoryResponseDto
     */
    surgeriesHospitalizations?: string;
    /**
     * Significant injuries
     * @type {string}
     * @memberof MedicalHistoryResponseDto
     */
    significantInjuries?: string;
    /**
     * Allergies
     * @type {string}
     * @memberof MedicalHistoryResponseDto
     */
    allergies?: string;
}

/**
 * Check if a given object implements the MedicalHistoryResponseDto interface.
 */
export function instanceOfMedicalHistoryResponseDto(value: object): value is MedicalHistoryResponseDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    return true;
}

export function MedicalHistoryResponseDtoFromJSON(json: any): MedicalHistoryResponseDto {
    return MedicalHistoryResponseDtoFromJSONTyped(json, false);
}

export function MedicalHistoryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalHistoryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'pastMedicalHistory': json['pastMedicalHistory'] == null ? undefined : PastMedicalHistoryDtoFromJSON(json['pastMedicalHistory']),
        'surgeriesHospitalizations': json['surgeriesHospitalizations'] == null ? undefined : json['surgeriesHospitalizations'],
        'significantInjuries': json['significantInjuries'] == null ? undefined : json['significantInjuries'],
        'allergies': json['allergies'] == null ? undefined : json['allergies'],
    };
}

export function MedicalHistoryResponseDtoToJSON(json: any): MedicalHistoryResponseDto {
    return MedicalHistoryResponseDtoToJSONTyped(json, false);
}

export function MedicalHistoryResponseDtoToJSONTyped(value?: MedicalHistoryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'pastMedicalHistory': PastMedicalHistoryDtoToJSON(value['pastMedicalHistory']),
        'surgeriesHospitalizations': value['surgeriesHospitalizations'],
        'significantInjuries': value['significantInjuries'],
        'allergies': value['allergies'],
    };
}

